import { EquipmentType } from "@/types/baseTypes";
import styles from "./EquipmentRecipe.module.scss";
import { ReactSVG } from "react-svg";
import Image from "next/image";

interface EquipmentRecipeProps {
  equipmentList: EquipmentType[];
}

export const EquipmentRecipe = ({ equipmentList }: EquipmentRecipeProps) => {
  return (
    <div className={`${styles["equipment"]} `} data-lenis-prevent>
      {equipmentList.map((equipment) => {
        const {
          utensilien_id,
          utensilien_titel,
          utensilien_img,
          utensilien_img_height,
          utensilien_img_width,
          utensilien_svg,
          utensilien_svg_height,
          utensilien_svg_width,
        } = equipment;
        return (
          <figure
            key={`equipment-${utensilien_id}`}
            className={`is-flex  is-flex-direction-column is-align-items-center ${styles["equipment-item"]}`}
          >
            <div className={styles["placeholder-image"]}>
              {utensilien_img ? (
                <Image
                  src={utensilien_img}
                  alt={utensilien_titel}
                  width={utensilien_img_width}
                  height={utensilien_img_height}
                />
              ) : utensilien_svg ? (
                <ReactSVG
                  src={utensilien_svg}
                  wrapper="svg"
                  width={utensilien_svg_width}
                  height={utensilien_svg_height}
                  aria-hidden
                />
              ) : (
                <></>
              )}
            </div>
            {equipment.utensilien_titel && (
              <figcaption>
                <p className="mt-4 pb-0">{equipment.utensilien_titel}</p>
              </figcaption>
            )}
          </figure>
        );
      })}
    </div>
  );
};
export default EquipmentRecipe;
